module.exports = __webpack_public_path__ + "media/images/patterns/header-c76f5d5e6a6dc123c551171723df6857.png";